/* eslint-disable no-nested-ternary */
/**
 * Recursively collect "name" values from schema elements.
 *
 * @param {Array} schema - The schema array
 * @param {string} prefix - Path prefix for nested names
 * @param {Object} options - Config options
 * @param {boolean} options.includeParents - Whether to include parent nodes with children
 * @param {boolean} options.stripParentFromLeaf - Whether to remove parent path from leaf names
 * @returns {string[]} - Array of name paths
 */
function getNamesFromSchema(
  schema,
  prefix = '',
  options = { includeParents: false, stripParentFromLeaf: true },
) {
  if (!Array.isArray(schema)) return [];

  return schema.flatMap(item => {
    const hasChildren =
      Array.isArray(item.children) && item.children.length > 0;
    const fullPath = item?.name
      ? prefix
        ? `${prefix}.${item.name}`
        : item.name
      : prefix;
    const leafName = item?.name ? item.name : '';

    if (hasChildren) {
      const children = getNamesFromSchema(item.children, fullPath, options);
      return options.includeParents && item?.name
        ? [fullPath, ...children]
        : children;
    }

    if (!item?.name) return [];

    return options.stripParentFromLeaf ? [leafName] : [fullPath];
  });
}

export default getNamesFromSchema;
